<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold"
        >“We’ve trained everyone to think and act with clarity.”
      </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      That’s high-functioning alignment in action. Your team doesn’t wait to be
      told what to do - they know what the mission is and how to support it.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      This is the essence of a Fast Attack crew - every member trained to lead,
      adapt, and execute when the moment calls for it.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Now ask: <span class="italic"
        >Is that clarity applied consistently under pressure?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Test it with scenarios: How would we respond to X? Then train to close the
      gaps.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold">“It depends on the department.” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This shows <span class="font-bold">partial alignment</span> - but fragmented
      in practice.
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      Different teams operate with different decision rules, which leads to
      confusion, delay, and mixed outcomes.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      A sub can’t run 5 different protocols. Coordination collapses if
      everyone’s playing by their own rulebook.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Define your company’s “decision doctrine.” What’s our shared approach to
      making the call?
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Whether in ops, marketing, or sales - the process should reflect a shared
      leadership culture.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold">“I usually make the final call.” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      You’re the central processor. That may feel efficient - but it’s limiting.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      This is like the captain steering every station - fast in calm waters, but
      a liability in the storm.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic"
        >What’s keeping others from making calls? Clarity, confidence, or
        permission?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Start by pushing one high-frequency decision down the chain - with clear
      boundaries - and coach them through it.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold">“Honestly? It’s chaos.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is an urgent breakdown - not just in alignment, but in leadership
      structure itself.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      In Fast Attack terms, this is a crew without command - reacting,
      improvising, and eventually losing control.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      It’s time to install decision-making structure. Build a fast, simple
      framework:
    </p>
    <ul class="list-disc ml-6 lg:ml-8">
      <li class="mt-1 text-sm lg:text-base/7 text-gray-600">Who decides</li>
      <li class="mt-1 text-sm lg:text-base/7 text-gray-600">How we decide</li>
      <li>When to escalate</li>
    </ul>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Your team doesn’t need perfection - just a process they can trust.
    </p>
  {/if}
</div>
